import { FeatureCalendar } from '@mdlbeasts/nofomo.ui.web';

import ResponsiveDrawerDialog from 'components/@common/ResponsiveDrawerDialog';
import FavoriteToggle from 'components/@favorites/FavoriteToggle';

interface Props {
  isOpen: boolean;
  // The open day, "yyyy-MM-dd". The kit picks this day's events off the list.
  dayKey: string;
  // Pre-formatted day, e.g. "July 10, 2026".
  dateLabel: string;
  // The open day as "July 10", shown on each row.
  eventDate: string;
  // Earliest navigable day, "yyyy-MM-dd". Back stops here.
  minDayKey?: string;
  events: Array<FeatureCalendar.CalendarEvent>;
  dayHourOffset?: number;
  onClose: () => void;
  onPressEvent: (slug: string) => void;
  onChangeDay: (dayKey: string) => void;
}

// Modal on desktop, bottom sheet on mobile. The shell owns the close button.
const EventDayDialog = ({
  isOpen,
  dayKey,
  dateLabel,
  eventDate,
  minDayKey,
  events,
  dayHourOffset,
  onClose,
  onPressEvent,
  onChangeDay,
}: Props) => (
  <ResponsiveDrawerDialog isOpen={isOpen} onClose={onClose}>
    <FeatureCalendar.EventDay
      dayKey={dayKey}
      dateLabel={dateLabel}
      eventDate={eventDate}
      minDayKey={minDayKey}
      events={events}
      dayHourOffset={dayHourOffset}
      renderBookmark={(slug) => (
        <FavoriteToggle
          type="event"
          value={slug}
          testID={`calendar-bookmark-${slug}`}
        />
      )}
      actions={{ press: onPressEvent, changeDay: onChangeDay }}
      testID="calendar-event-day"
    />
  </ResponsiveDrawerDialog>
);

export default EventDayDialog;
